export default __webpack_public_path__ + "static/media/digital-devonport.5df0a148.jpg";